const n = {
  labelFontSize: "16px",
  labelFontWeight: "500",
  hintFontSize: "14px",
  hintFontWeight: "400",
  inputHeight: "80px",
  inputWidth: "80px",
  inputFontSize: "48px"
}, i = {
  labelFontSize: "16px",
  labelFontWeight: "500",
  hintFontSize: "14px",
  hintFontWeight: "400",
  inputHeight: "64px",
  inputWidth: "64px",
  inputFontSize: "48px"
}, p = {
  labelFontSize: "14px",
  labelFontWeight: "500",
  hintFontSize: "13px",
  hintFontWeight: "400",
  inputHeight: "56px",
  inputWidth: "56px",
  inputFontSize: "36px"
}, e = {
  labelFontSize: "13px",
  labelFontWeight: "500",
  hintFontSize: "12px",
  hintFontWeight: "400",
  inputHeight: "48px",
  inputWidth: "48px",
  inputFontSize: "30px"
}, o = {
  labelFontSize: "12px",
  labelFontWeight: "500",
  hintFontSize: "11px",
  hintFontWeight: "400",
  inputHeight: "40px",
  inputWidth: "40px",
  inputFontSize: "24px"
}, h = {
  labelFontSize: "11px",
  labelFontWeight: "500",
  hintFontSize: "11px",
  hintFontWeight: "400",
  inputHeight: "36px",
  inputWidth: "36px",
  inputFontSize: "20px"
}, F = (t = "md") => ({
  lg: n,
  md: i,
  sm: p,
  xs: e,
  "2xs": o,
  "3xs": h
})[t] || {};
export {
  F as getInputOtpSizeStyles
};
